<ng-container *ngIf="fundPerformanceData?.length">
  <div
    edsGrid
    aria-live="polite"
    aria-atomic="true"
    [attr.id]="containerId ? containerId : null"
  >
    <div edsRow>
      <table
        class="table"
        #tableResponsive
        [style.display]="(isHandheld$ | async) ? 'none' : ''"
      >
        <thead>
          <tr class="table__tr">
            <th class="table__th table__th--padding-right-none"></th>
            <th class="table__th table__th--padding-left-none">
              <p class="spacing--none">
                {{ tableLabel | translate: fundId }}
              </p>
              <p class="small spacing--none">
                {{ "products.as-of" | translate }}
                {{ fundPerformanceDates.asOfDate }}
              </p>
            </th>
            <th
              class="table__th text-align-right table__th--middle table__th--padding-left-none"
              *ngIf="fundPerformanceConfig?.showCurrency"
            >
              <span
                class="text-align-right"
                edsFlexbox
                justifyContent="flex-end"
              >
                {{ "products.currency" | translate }}
              </span>
            </th>
            <th
              class="table__th text-align-right table__th--middle table__th--padding-left-none"
              *ngIf="showYearToDate"
            >
              <span
                class="text-align-right"
                edsFlexbox
                justifyContent="flex-end"
              >
                {{ "products.yearToDate" | translate }}
              </span>
            </th>
            <th
              class="table__th table__th--middle table__th--padding-left-none"
              *ngFor="let year of years"
            >
              <span
                class="text-align-right"
                edsFlexbox
                justifyContent="flex-end"
              >
                {{ year }}
              </span>
            </th>
            <th
              class="table__th table__th--middle table__th--padding-left-none"
              [class.table__th--padding-right-none]="isAllShareClasses"
            >
              <p
                class="spacing--none text-align-right"
                edsPadding
                edsPaddingRight="md"
                edsFlexbox
                justifyContent="flex-end"
              >
                {{ "products.inception-date" | translate }}
              </p>
            </th>
            <th
              class="table__th table__th--middle table__th--padding-left-none"
              *ngIf="isAllShareClasses"
            >
              <p
                class="spacing--none text-align-right"
                edsPadding
                edsPaddingRight="md"
                edsFlexbox
                justifyContent="flex-end"
              >
                {{ "products.fund-info-perf" | translate }}
              </p>
            </th>
          </tr>
        </thead>

        <tbody *ngIf="fundPerformanceData?.length" class="table__body">
          <tr class="table__tr" *ngFor="let row of fundPerformanceData">
            <td class="table__td table__td--padding-right-none">
              <span
                *ngIf="!isAllShareClasses && !row?.hideOnChart"
                class="table__legend"
                edsSpacing
                ><span
                  class="table__legend-box"
                  [style.background]="row.pointColor"
                ></span
              ></span>
            </td>
            <td
              class="table__td"
              [class.table__td--padding-left-none]="!isAllShareClasses"
            >
              {{ row.name }}
              <ng-container *ngIf="row.calcTypeLabel">
                {{ row.calcTypeLabel | translate }}
              </ng-container>
              {{ "(%)" }}
              <eds-footnote
                *ngIf="!isAllShareClasses"
                [placement]="'Calendar Year:' + row.placement"
              ></eds-footnote>
            </td>
            <td
              class="table__td text-align-right table__td--padding-left-none"
              *ngIf="fundPerformanceConfig?.showCurrency"
            >
              {{ row.currency }}
            </td>
            <td
              class="table__td text-align-right table__td--padding-left-none"
              *ngIf="showYearToDate"
            >
              {{ row.yearToDate }}
            </td>
            <td
              class="table__td text-align-right table__td--padding-left-none"
              *ngFor="let col of tableCols"
            >
              {{ row[col] }}
            </td>
            <td
              class="table__td text-align-right table__td--padding-left-none"
              [class.table__td--padding-right-none]="isAllShareClasses"
            >
              <span edsPadding edsPaddingRight="md">{{
                row.inceptionDate
              }}</span>
            </td>
            <td
              class="table__td text-align-center table__td--padding-left-none"
              *ngIf="isAllShareClasses"
            >
              <eds-link-item
                [title]="'products.fund-information-perf' | translate"
                [href]="row.link"
                edsFlexbox
                justifyContent="center"
              ></eds-link-item>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
    <div edsRow *ngFor="let card of cards; let cardIndex = index">
      <div edsCol *ngIf="isHandheld$ | async">
        <eds-panel
          edsSpacing="sm"
          [hasBorders]="true"
          [hasBorderRadius]="false"
          [hasPadding]="true"
          [theme]="'white'"
        >
          <eds-info-item
            *ngFor="let item of card; let itemIndex = index"
            [info]="item"
            edsSpacing="sm"
          >
            <ng-container
              *ngIf="!isAllShareClasses && itemIndex === 0 && removeValue(item)"
            >
              <span
                class="table__legend"
                edsPadding
                edsPaddingLeft="xs"
                edsFlexbox
                alignItems="flex-start"
              >
                <span
                  class="table__legend-box table__legend-box--spacing-none"
                  [style.background]="fundPerformanceData[cardIndex].pointColor"
                ></span>
                <span edsPadding edsPaddingLeft="xs">
                  {{ fundPerformanceData[cardIndex].name }}
                  <ng-container
                    *ngIf="fundPerformanceData[cardIndex].calcTypeLabel"
                  >
                    {{
                      fundPerformanceData[cardIndex].calcTypeLabel | translate
                    }}
                  </ng-container>
                  {{ "(%)" }}
                  <eds-footnote
                    [placement]="
                      'Calendar Year:' +
                      fundPerformanceData[cardIndex].placement
                    "
                  ></eds-footnote>
                </span>
              </span>
            </ng-container>

            <ng-container
              *ngIf="
                isAllShareClasses &&
                itemIndex === card.length - 1 &&
                removeValue(item)
              "
            >
              <eds-link-item
                [title]="'products.fund-information-perf' | translate"
                [href]="fundPerformanceData[cardIndex].link"
                [forceRightAlign]="(isHandheld$ | async) ? true : false"
              ></eds-link-item>
            </ng-container>
          </eds-info-item>
        </eds-panel>
      </div>
    </div>
  </div>
</ng-container>
